import { Reveal } from "@/components/Reveal";

const AKSigorta = () => (
  <span data-testid="insurance-logo-ak-sigorta" className="font-display text-2xl leading-none text-[#E30613]">
    <span className="font-extrabold tracking-tight">AK</span>
    <span className="font-semibold"> Sigorta</span>
  </span>
);

const AnadoluSigorta = () => (
  <span data-testid="insurance-logo-anadolu-sigorta" className="flex flex-col leading-none">
    <span className="font-display text-xl font-extrabold tracking-wide text-[#002F6C]">ANADOLU</span>
    <span className="mt-1 font-display text-[11px] font-bold tracking-[0.4em] text-[#3A6BBD]">SİGORTA</span>
  </span>
);

const Allianz = () => (
  <span data-testid="insurance-logo-allianz" className="flex items-center gap-2.5">
    <svg viewBox="0 0 24 24" className="h-7 w-7" aria-hidden="true">
      <rect x="3.5" y="5" width="4.6" height="14" rx="2.3" fill="#003781" />
      <rect x="9.7" y="5" width="4.6" height="14" rx="2.3" fill="#003781" />
      <rect x="15.9" y="5" width="4.6" height="14" rx="2.3" fill="#003781" />
    </svg>
    <span className="font-display text-2xl font-bold tracking-tight text-[#003781]">Allianz</span>
  </span>
);

const SompoJapan = () => (
  <span data-testid="insurance-logo-sompo-japan" className="flex items-center gap-2.5">
    <svg viewBox="0 0 24 24" className="h-7 w-7" aria-hidden="true">
      <circle cx="12" cy="12" r="10" fill="#E50012" />
      <path d="M6.5 12c2.8-4.8 8.2-4.8 11 0-2.8 4.8-8.2 4.8-11 0z" fill="#fff" />
      <circle cx="12" cy="12" r="2.4" fill="#E50012" />
    </svg>
    <span className="flex flex-col leading-none">
      <span className="font-display text-lg font-extrabold tracking-wide text-[#1A1A1A]">SOMPO</span>
      <span className="mt-1 font-display text-[11px] font-bold tracking-[0.35em] text-[#E50012]">JAPAN</span>
    </span>
  </span>
);

const UnicoSigorta = () => (
  <span data-testid="insurance-logo-unico-sigorta" className="flex items-center gap-2">
    <svg viewBox="0 0 24 24" className="h-7 w-7" aria-hidden="true">
      <path d="M5 3.5v9.5a7 7 0 0 0 14 0V3.5h-4.4v9.5a2.6 2.6 0 0 1-5.2 0V3.5z" fill="#00AFA9" />
    </svg>
    <span className="flex items-baseline gap-1.5 leading-none">
      <span className="font-display text-2xl font-bold tracking-tight text-[#00AFA9]">Unico</span>
      <span className="text-[11px] font-bold tracking-wide text-slate-500">Sigorta</span>
    </span>
  </span>
);

const HdiSigorta = () => (
  <span data-testid="insurance-logo-hdi-sigorta" className="flex items-baseline gap-2 leading-none">
    <span className="font-display text-2xl font-extrabold tracking-tight text-[#009A44]">
      HD<span className="text-[#E30613]">I</span>
    </span>
    <span className="text-sm font-semibold tracking-wide text-[#1A1A1A]">Sigorta</span>
  </span>
);

const LOGOS = [
  { id: "ak", C: AKSigorta },
  { id: "anadolu", C: AnadoluSigorta },
  { id: "allianz", C: Allianz },
  { id: "sompo", C: SompoJapan },
  { id: "unico", C: UnicoSigorta },
  { id: "hdi", C: HdiSigorta },
];

export const SigortaBand = () => (
  <section data-testid="insurance-band" className="bg-slate-50 py-12 lg:py-14">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-brand">
          Sigorta Şirketleri
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-12 gap-y-8">
          {LOGOS.map(({ id, C }) => (
            <C key={id} />
          ))}
        </div>
        <p className="mt-8 text-center text-sm font-semibold text-slate-500" data-testid="insurance-band-note">
          ve tüm sigorta şirketleri…
        </p>
      </Reveal>
    </div>
  </section>
);

export default SigortaBand;
